import gql from 'graphql-tag'

export const anuncioFragment = gql`
  fragment AnuncioFragment on Anuncio {
    id
    titulo
    link
    linkTarget
    inicioDate
    fimDate
    arquivo {
      id
      nome
    }
    grupos {
      id
      nome
    }
    active
    createdDateTime
    emExibicao
  }
`
